@import '~style-sheet-helpers/core.less';
@import '../../../../../../app-brand/entities/entity-layer.module.less';

.removable-service {
  display: flex;
  align-items: center;
  background: @settings-page--stores-selected-checkout-removable--background-color;
  padding: 0 16px;
  font-size: 14px;
  line-height: 30px;
  border: 1px solid @settings-page--stores-selected-checkout-removable--border-color;

  &:not(:last-child) {
    margin-bottom: 5px;
  }

  i {
    color: @settings-page--stores-selected-checkout-italic--text-color;
  }

  > * {
    &:first-child {
      flex-grow: 1;
    }

    &:not(:last-child) {
      margin-right: 16px;
    }
  }
}

.x-button {
  height: 30px;
  width: 30px;
  cursor: pointer;

  &:hover {
    svg {
      fill: @settings-page--stores-selected-checkout-removable--hover--fill-color;
    }
  }
}

.icon {
  height: 30px;
  width: 30px;
  padding: 10px;
}
